module.exports = __webpack_public_path__ + "static/media/token_active.b3eb1a0e.svg";